import React from 'react';

import { AccordionDetails } from '@material-ui/core';

import { ApplicationAutomations } from '../application-automations';
import { BirthdayAutomations } from '../birthday-automations';
import { EmployeeAutomations } from '../employee-automations';
import { HiringAutomations } from '../hiring-automations';
import { OnboardingAutomations } from '../onboarding-automations';
import { StyledAccordion } from '../ui/styled-accordion';
import { StyledAccordionSummary } from '../ui/styled-accordion-summary';

import { ICON_NAMES, MaterialDesignIcon } from '../../../util/material-design-icons';
import { getSectionForApplicantAutomation } from '../../utils/applicant-automation-display-utils';

export const AutomationTimelineSection = ({
  org,
  editingForJob,
  title,
  sectionKey,
  disabled,
  focusApplicantAutomation,
}: {
  org: Org;
  editingForJob?: Job;
  title: string;
  sectionKey: string;
  disabled?: boolean;
  focusApplicantAutomation?: ApplicantAutomation | null;
}) => {
  const sectionComponents: Record<string, React.ReactNode> = {
    application: (
      <ApplicationAutomations
        org={org}
        editingForJob={editingForJob}
        focusApplicantAutomation={focusApplicantAutomation}
      />
    ),
    hiring: (
      <HiringAutomations
        org={org}
        editingForJob={editingForJob}
        focusApplicantAutomation={focusApplicantAutomation}
      />
    ),
    onboarding: (
      <OnboardingAutomations
        org={org}
        editingForJob={editingForJob}
        focusApplicantAutomation={focusApplicantAutomation}
      />
    ),
    employee: <EmployeeAutomations org={org} />,
    birthday: <BirthdayAutomations org={org} />,
  };

  const alwaysExpanded = sectionKey === 'birthday';
  const defaultExpanded =
    !!focusApplicantAutomation &&
    getSectionForApplicantAutomation(focusApplicantAutomation) === sectionKey;

  return (
    <StyledAccordion
      defaultExpanded={alwaysExpanded || defaultExpanded}
      disabled={disabled}
      data-cy={sectionKey}
    >
      <StyledAccordionSummary
        disabled={alwaysExpanded}
        expandIcon={
          alwaysExpanded ? null : (
            <MaterialDesignIcon
              iconName={ICON_NAMES.EXPAND_MORE}
              style={disabled ? { opacity: 0 } : {}}
            />
          )
        }
      >
        <div className="typo-title typo-medium u-color-primary u-padding-top-sm">{title}</div>
      </StyledAccordionSummary>
      {!disabled && <AccordionDetails>{sectionComponents[sectionKey]}</AccordionDetails>}
    </StyledAccordion>
  );
};
